// extracted by mini-css-extract-plugin
export default {"formContainer":"formComponent_formContainer__AlfCR"};